"use client";
import { Check } from "lucide-react";
import { Icons } from "../assets/icons/Icons";

const Input = ({
    label,
    id,
    placeholder,
    value,
    onChange,
    type = "text",
    className = "",
    labelClassName = "mb-1 font-600",
    inputClassName = "form-control form-control-lg border-0 text-white rounded-3",
    active = false,
    readOnly = false,
    icon,
    rightIcon,
    bgType = "black", // New prop for background type: "black", "dark", or "gray"
    ...props
}) => {
    // Determine background color based on bgType
    let bgColor = "rgba(20, 20, 20, 1)"; // Default black
    if (bgType === "dark") bgColor = "rgba(20, 20, 20, 1)";
    if (bgType === "gray") bgColor = "rgba(30, 30, 30, 1)";

    return (
        <div className={`mb-3 ${className}`}>
            {label && (
                <label
                    htmlFor={id}
                    className={labelClassName}
                    style={{ color: "#797373", fontSize: "10px" }}
                >
                    {label}
                </label>
            )}
            <div className="position-relative">
                {icon && (
                    <div className="position-absolute start-0 top-50 translate-middle-y ms-3">
                        {icon}
                    </div>
                )}
                <input
                    type={type}
                    className={`${inputClassName} ${icon ? "ps-5" : ""}`}
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    readOnly={readOnly}
                    {...props}
                    style={{
                        height: "50px",
                        backgroundColor: bgColor,
                        ...props.style,
                    }}
                />
                {active && (
                    <div
                        className="position-absolute end-0 top-50 translate-middle-y me-3"
                        style={{}}
                    >
                        <Icons.ActiveCkeckMarkIcon />
                    </div>
                )}
                {rightIcon && !active && (
                    <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                        {rightIcon}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Input;
